import { CardHeaderProps as MuiCardHeaderProps } from '@mui/material/CardHeader'

export type CardHeaderProps = MuiCardHeaderProps
